/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageForward = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M13.859 8.157l-.001-.001-.001-.001-3.978-3.991a.5.5 0 1 0-.709.705l1.149 1.152H2.492a.496.496 0 0 0-.496.495v4c0 .274.222.496.496.496h7.823L9.17 12.164a.5.5 0 1 0 .709.705l3.979-4.005v-.001l.001-.001c.043-.042.04-.102.063-.153.031-.067.082-.127.082-.2 0-.082-.053-.153-.093-.227-.023-.041-.017-.09-.052-.125z"
    />
  </svg>
);

IconMessageForward.displayName = 'IconMessageForward';

IconMessageForward.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageForward);
IconMessageForward.displayName = 'IconMessageForward';
